import { useContext } from 'react';

import i18n from '@nextroll/ar-i18n';

import ThemeWrapperContext from '../../../contexts/ThemeWrapperContext';
import PageBanner from '../PageBanner';

const SystemErrorView = () => {
    const { supportEmail } = useContext(ThemeWrapperContext);

    const topText = i18n.gettext('Oops, an error has occurred');
    const bottomText = i18n.gettext('Here are a few options that might help:');

    const options = [
        i18n.gettext('Refresh this page'),
        i18n.gettext('Click the verification link in your email again'),
        i18n.gettext(
            'Still having trouble? Reach out to <LINK>{{supportEmailAddress}}</LINK> or your Account Executive.',
            {
                LINK: <a href={`mailto:${supportEmail}`} target='_blank' />,
                supportEmailAddress: supportEmail,
            }
        ),
    ];

    return (
        <div className='eh-ev-form-view-system-error'>
            <PageBanner
                error={true}
                topText={topText}
                bottomText={bottomText}
                className='status-error'
            />
            <ul className='eh-ev-bottom-text'>
                {options.map((option) => (
                    <li key={option}>
                        <span>{option}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default SystemErrorView;
